import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CloudOffIcon from '@mui/icons-material/CloudOff';
import ProjectFileExplorer from './ProjectFileExplorer';

/**
 * Project file explorer with a guard for projects that have no network
 * storage assigned.
 */
export const ProjectFilesPanel = ({ project }) => {
  const { t } = useTranslation();

  if (!project.networkStorage)
    return (
      <Box className="w-full h-full flex flex-col items-center justify-center gap-2 opacity-60 py-16">
        <CloudOffIcon sx={{ fontSize: '40px' }} />
        <Typography variant="body2">
          {t('This project has no network storage configured.')}
        </Typography>
      </Box>
    );

  return <ProjectFileExplorer projectId={project.id} />;
};

export default ProjectFilesPanel;
